import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {WhtspPage} from "../whtsp/whtsp";
import {ErpAdmissionPage} from "../erp-admission/erp-admission";
import {ContactPage} from "../contact/contact";
import {SchoolEnquiryPage} from "../school-enquiry/school-enquiry";


@Component({
  selector: 'page-communication',
  templateUrl: 'communication.html',
})
export class CommunicationPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CommunicationPage');
  }

  go_to_Whtsp(){
    this.navCtrl.push(WhtspPage);
  }

  go_to_Adm(){
    this.navCtrl.push(ErpAdmissionPage);
  }

  go_to_Contact(){
    this.navCtrl.push(ContactPage);
  }

  go_to_Enquiry(){
    this.navCtrl.push(SchoolEnquiryPage);
  }


}



// WEBPACK FOOTER //
// ./src/pages/communication/communication.ts